import * as Backbone from "backbone";
import {CachingCollection} from "./_BaseCollection";

interface DashboardNotificationCollectionOptions {
    dashboardId?: number;
    userGroupId: number
}

export class DashboardNotificationCollection extends CachingCollection<Backbone.Model> {

    dashboardId: number;
    userGroupId: number;

    url = () => {
        if (this.dashboardId) {
            return '/api/v1/notifications/dashboard/' + this.userGroupId + '/' + this.dashboardId
        } else {
            return '/api/v1/notifications/dashboard/' + this.userGroupId
        }
    };

    constructor(initialModels: Object[] | any[], options: DashboardNotificationCollectionOptions) {
        super(initialModels, options);
        this.dashboardId = options.dashboardId ?? null;
        this.userGroupId = options.userGroupId;
    }

    comparator = (model) => {
        return model.get('order');
    }
}




// WEBPACK FOOTER //
// ./srv/public/js/collections/DashboardNotifications.ts